import { useState, useEffect, useRef } from "react";
import styled, { createGlobalStyle, keyframes, css } from "styled-components";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Area, AreaChart, CartesianGrid } from "recharts";
import { isMobile} from 'react-device-detect';
import { PieChart, Pie, Cell } from "recharts";
import iconlogo from '../assets/iconLogo.png'
import HeaderBell from "./HeaderBell";
import { useNavigate } from "react-router-dom";
import Request from "./Request";
import CenterPage from './Business';
import Swal from "sweetalert2";
import { construct, messageDisplay, roundUpToDecimal,T } from "./Util";
import Popup from "./Popup";
import { addLocation, getRequestBeeppeePayout, getRequestOustanding, getRequestProfit, getRequestToEmail, pullNotification} from "../Logic/index01";
import Requesthistory from "./History";









const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
`;




const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: ${T.font}; background: ${T.bg}; color: ${T.text}; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }
`;




const Shell = styled.div`
  display: flex;
  height: 100vh;

`;




const Sidebar = styled.aside`
  width: 224px;
  flex-shrink: 0;
  background: ${T.surface};
  border-right: 1px solid ${T.border};
  flex-direction: column;
  overflow-y: auto;
`;




const LogoIcon = styled.div`
  width: 44px; height: 44px;
  background: ${T.blue};
  border-radius: 100%;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
`;



const LogoText = styled.div`
  p:first-child { font-size: 13px; font-weight: 600; color: ${T.text}; line-height: 1.2; }
  p:last-child  { font-size: 10px; color: ${T.subtle}; margin-top: 1px; }
`;



const NavSection = styled.div`
  padding: ${({ top }) => top ? "20px 16px 6px" : "16px 16px 6px"};
`;

const SectionLabel = styled.p`
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${T.subtle};
  margin-bottom: 6px;
`;

const NavList = styled.nav`
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const NavItem = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 13.5px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  border-right: 3px solid transparent;

  ${({ $active }) => $active ? css`
    background: ${T.blueLight};
    color: ${T.blue};
    border-right-color: ${T.blue};
    border-radius: 10px 0 0 10px;
  ` : css`
    color: ${T.muted};
    &:hover { background: #f5f7ff; color: ${T.blue}; }
  `}

  svg { width: 16px; height: 16px; flex-shrink: 0; }
`;

const Spacer = styled.div`flex: 1;`;



const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

/* ─────────────────────────────────────────
   TOPBAR
───────────────────────────────────────── */
const Topbar = styled.header`
  background: ${T.surface};
  border-bottom: 1px solid ${T.border};
  padding: 14px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`;

const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: ${T.text};
`;

const TopbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const SearchWrap = styled.div`
  position: relative;
  svg { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); width: 15px; height: 15px; color: ${T.subtle}; }
`;

const SearchInput = styled.input`
  padding: 8px 14px 8px 36px;
  background: #f8fafc;
  border: 1px solid ${T.border};
  border-radius: 12px;
  font-size: 13px;
  color: ${T.muted};
  font-family: ${T.font};
  width: 210px;
  outline: none;
  transition: border 0.15s, box-shadow 0.15s;
  &:focus { border-color: #93c5fd; box-shadow: 0 0 0 3px rgba(37,99,235,.08); }
`;





const AvatarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const Avatar = styled.div`
  width: 34px; height: 34px;
  background: ${T.blue};
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.03em;
`;

const AvatarInfo = styled.div`
  p:first-child { font-size: 12px; font-weight: 600; color: ${T.text}; line-height: 1.2; }
  p:last-child  { font-size: 10px; color: ${T.subtle}; }
`;

/* ─────────────────────────────────────────
   BODY
───────────────────────────────────────── */
const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Greeting = styled.p`
  font-size: 17px;
  font-weight: 600;
  color: ${T.text};
  animation: ${fadeUp} 0.4s ease both;
`;

/* ─────────────────────────────────────────
   CARDS
───────────────────────────────────────── */
const Card = styled.div`
  background: ${T.surface};
  border-radius: 16px;
  border: 1px solid ${T.border};
  transition: box-shadow 0.2s, transform 0.2s;
  &:hover { box-shadow: 0 8px 30px rgba(0,0,0,.08); transform: translateY(-2px); }
  animation: ${fadeUp} 0.4s ease both;
  animation-delay: ${({ $delay }) => $delay || "0s"};
`;

const Row = styled.div`
  grid-template-columns: ${({ $cols }) => $cols || "1fr"};
  gap: 16px;
  animation: ${fadeUp} 0.4s ease both;
  animation-delay: ${({ $delay }) => $delay || "0s"};
`;

/* ─────────────────────────────────────────
   STAT CARD
───────────────────────────────────────── */
const StatCard = styled(Card)`
  padding: 20px;
`;

const StatIcon = styled.div`
  width: 36px; height: 36px;
  background: ${({ $bg }) => $bg};
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 14px;
  svg { width: 18px; height: 18px; color: ${({ $color }) => $color}; }
`;

const StatLabel = styled.p`
  font-size: 12.5px;
  color: ${T.muted};
  font-weight: 500;
  margin-bottom: 4px;
`;

const StatValueRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

const StatValue = styled.p`
  font-size: 30px;
  font-weight: 700;
  font-family: ${T.mono};
  color: ${T.text};
  line-height: 1;
`;

const StatArrow = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${({ $up }) => $up ? T.green : T.red};
  margin-bottom: 3px;
  display: flex;
  align-items: center;
`;

/* ─────────────────────────────────────────
   REVENUE CARD
───────────────────────────────────────── */
const RevenueCard = styled(Card)`
  padding: 20px;
  justify-content:center;
`;

const RevenueHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`;

const CardTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: ${T.text};
`;

const PeriodSelect = styled.p`
  font-size: 12px;
  color: ${T.muted};
  border: 1px solid ${T.border};
  border-radius: 8px;
  padding: 4px 8px;
  background: #fff;
  font-family: ${T.font};
  outline: none;
  cursor: pointer;
`;

const NetVolRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
`;

const CyanDot = styled.span`
  width: 10px; height: 10px;
  background: ${T.cyan};
  border-radius: 2px;
  display: inline-block;
`;

const NetVolLabel = styled.span`
  font-size: 11.5px;
  color: ${T.subtle};
`;

const RevenueAmountRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const RevenueAmount = styled.p`
  font-size: 22px;
  font-weight: 700;
  font-family: ${T.mono};
  color: ${T.text};
`;

const GrowthBadge = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${T.green};
  background: ${T.greenLight};
  padding: 2px 8px;
  border-radius: 20px;
`;

/* ─────────────────────────────────────────
   SATISFACTION
───────────────────────────────────────── */
const SatisfactionCard = styled(Card)`
  padding: 20px;
  flex: 1;
`;

const GaugeWrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 8px 0 2px;
`;

const GaugeLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: ${T.subtle};
  padding: 0 8px;
  margin-bottom: 12px;
`;

const SatisfactionHint = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fefce8;
  border-radius: 10px;
  padding: 10px 12px;
`;

const HintEmoji = styled.span` font-size: 18px; line-height: 1; flex-shrink: 0; `;

const HintText = styled.div`
  p:first-child { font-size: 11px; font-weight: 600; color: #374151; line-height: 1.3; }
  p:last-child  { font-size: 10px; color: ${T.subtle}; margin-top: 4px; line-height: 1.5; }
`;

/* ─────────────────────────────────────────
   ANALYTICS CARD
───────────────────────────────────────── */
const AnalyticsCard = styled(Card)`
  padding: 20px;
  flex: 1;
`;

const AnalyticsBody = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 12px;
`;

const DonutWrap = styled.div`
  position: relative;
  width: 110px;
  height: 110px;
  flex-shrink: 0;
`;

const DonutCenter = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  p:first-child { font-size: 15px; font-weight: 700; color: ${T.text}; font-family: ${T.mono}; }
  p:last-child  { font-size: 9px; color: ${T.subtle}; }
`;

const LegendList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
`;

const LegendDot = styled.span`
  width: 8px; height: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`;

const LegendLabel = styled.span` color: ${T.muted}; flex: 1; `;
const LegendValue = styled.span`
  font-weight: 600;
  font-family: ${T.mono};
  font-size: 11px;
  color: ${({ $color }) => $color};
`;

/* ─────────────────────────────────────────
   CUSTOM TOOLTIP
───────────────────────────────────────── */
const TooltipBox = styled.div`
  background: #1e293b;
  border-radius: 8px;
  padding: 8px 12px;
  font-family: ${T.mono};
  p:first-child { font-size: 10px; color: #94a3b8; margin-bottom: 2px; }
  p:last-child  { font-size: 13px; color: #fff; font-weight: 500; }
`;

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <TooltipBox>
      <p>{label}</p>
      <p>₦{payload[0].value.toLocaleString()}</p>
    </TooltipBox>
  );
};

/* ─────────────────────────────────────────
   GAUGE CANVAS
───────────────────────────────────────── */
function GaugeCanvas({ value = 70, max = 100 }) {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const c = canvas.getContext("2d");
    const W = canvas.width, cx = W / 2, cy = canvas.height * 0.9, R = W * 0.42;
    const pct = value / max;
    c.clearRect(0, 0, W, canvas.height);

    // Track
    c.beginPath();
    c.arc(cx, cy, R, Math.PI, 0);
    c.lineWidth = 14;
    c.strokeStyle = "#e5e7eb";
    c.lineCap = "round";
    c.stroke();

    // Fill
    const grad = c.createLinearGradient(cx - R, cy, cx + R, cy);
    grad.addColorStop(0, "#3b82f6");
    grad.addColorStop(1, "#06b6d4");
    c.beginPath();
    c.arc(cx, cy, R, Math.PI, Math.PI + pct * Math.PI);
    c.lineWidth = 14;
    c.strokeStyle = grad;
    c.lineCap = "round";
    c.stroke();

    // Value
    c.font = `bold 22px 'DM Mono', monospace`;
    c.fillStyle = "#111827";
    c.textAlign = "center";
    c.textBaseline = "middle";
    c.fillText(value, cx, cy - 16);
    c.font = `10px 'DM Sans', sans-serif`;
    c.fillStyle = "#9ca3af";
    c.fillText("/100", cx + 20, cy - 4);
  }, [value, max]);

  return <canvas ref={ref} width={180} height={100} />;
}




const  Console = () => {



  const [openHistory, setopenHistory] = useState(false);
  const [openTab, setOpenTab] = useState(false);
  const [openRequest, setOpenRequest] = useState(false);
  const [openBusiness, setOpenbusiness] = useState(false);
  const [donutData, setdonutData] = useState([]);
  const [open, setOpen] = useState(false);
  const [total, setTotal] = useState([]);
  const [profit, setProfit] = useState(0);
  const [payout, setPayout] = useState(null);
  const [outstanding, setOutstanding] = useState(0);
  const [sum, setSum] = useState(0);
  const [update, setUpdate] = useState(0)
  const send = useNavigate();



const navItems = [
  { label: "Dashboard", active: true,  icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1.5" strokeWidth="2"/><rect x="14" y="3" width="7" height="7" rx="1.5" strokeWidth="2"/><rect x="3" y="14" width="7" height="7" rx="1.5" strokeWidth="2"/><rect x="14" y="14" width="7" height="7" rx="1.5" strokeWidth="2"/></svg> },
  { label: "History",   active: false, icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg> },
  { label: "Update address",   active: false, icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg> },
  { label: "Notifications", active: false, icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/></svg> },
];

const bottomNav = [
  { label: "Help & Support", icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" strokeWidth="2"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01"/></svg> },
  { label: "Logout",       icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/></svg> },
];

  

const toggle = () => {
    if(!open){
        setOpen(true)
    }else{
      setOpen(false);
    }
  }




  
  const sumup = async () => {
    if(construct(localStorage.getItem(process.env.REACT_APP_LS)) !== undefined ||  construct(localStorage.getItem(process.env.REACT_APP_LS)) != null){
        let res = await pullNotification();
    }
  }






  
  const pullInActivities = async () => {
          let resList = await getRequestToEmail("createdAt");
            if(resList){
              setTotal(resList);
              setdonutData([
                { name: "Completed", value: getOrderStats(resList).completedPercent, color: "#22d3ee"},
                { name: "Progress", value: getOrderStats(resList).pendingPercent, color: "#fbbf24" },
                { name: "Terminated", value: getOrderStats(resList).cancelledPercent, color: "#a78bfa"},
              ]);
            }
    }
    






  const pullCommissoinTotal = async () => {
          let resList = await getRequestOustanding();
          if(resList !== "Vendor not found"){
            setOutstanding(resList)
              let data = await getRequestProfit();
                if(data !== "Vendor not found"){
                    setProfit(data)
                }

          }else{
            send("/signin");
          }
    }


    

  function filter(v,i){
    return  total.length <= 0 ? 0 : i == 0 ? total.filter(r => r.complete === true && r.Status === true).reduce((accumulate,current) => accumulate
         + roundUpToDecimal(current.amount,2),0) : total.filter(r => v === "Complete" ? r.complete === true : 
           r.cancel === true  && r.Status === true && r.complete === false).length;
  }

  


  function getOrderStats(orderArray) {
    const counts = orderArray.reduce((acc, order) => {
      if (order.Status === true && order.complete === true) acc.completed++;
      if (order.cancel === true && order.complete === false) acc.cancelled++;
      if (order.Status === true && order.cancel === false ) acc.pending++;
      return acc;
    }, { completed: 0, cancelled: 0, pending: 0});
    const totalRelevantOrders = counts.completed + counts.cancelled +counts.pending;
    if (totalRelevantOrders === 0) {
      return { completedPercent: "0", cancelledPercent: "0", pendingPercent:"0", total: 0 };
    }
    return {
      completedPercent: ((counts.completed / totalRelevantOrders) * 100),
      cancelledPercent: ((counts.cancelled / totalRelevantOrders) * 100),
      pendingPercent: ((counts.pending / totalRelevantOrders) * 100),
      total: totalRelevantOrders
    };
}






function getOrderRating(orderArray) {
    const counts = orderArray.reduce((acc, order) => {
      if (order.customerRating === true && order.complete === true) acc.completed++;
      if (order.customerRating === false && order.cancel === true) acc.cancelled++;
      return acc;
    }, { completed: 0, cancelled: 0});
    const totalRelevantOrders = counts.completed + counts.cancelled;
    if (totalRelevantOrders === 0) {
      return { ratingPercent: "0", cancelledPercent: "0", total: 0 };
    }
    return {
      ratingPercent: ((counts.completed / totalRelevantOrders) * 100),
      cancelled: ((counts.cancelled / totalRelevantOrders) * 100),
      total: totalRelevantOrders
    };
}




  function sendInterval(){
    setInterval(() => {
        sumup() 
    },3000); 
  }
  
 

  const openTopNav = () => {
        if(!openTab){
          setOpenTab(true)
        }else{
          setOpenTab(false)
     }
  }



  const openOrder = () => {
        if(!openRequest){
          setOpenRequest(true)
        }else{
          setOpenRequest(false)
        }
      }




   const openHistoryTab = () => {
        if(!openHistory){
          setopenHistory(true)
        }else{
          setopenHistory(false)
        }
   }





   const mapBusiness = () => {
        if(openBusiness){
            setOpenbusiness(false)
        }else{
          setOpenbusiness(true);
        }
    }


  



  const navigations = (v) => {
    if(v == "History"){
            openHistoryTab()
    }else
         if(v == "Update address"){
            mapBusiness();
    }else
         if(v == "Dashboard"){
            setopenHistory(false);
            setOpenbusiness(false);
     }
       setOpenTab(false)
    }
    

  




    function updateLocation(){
       setInterval(() => {
        if(navigator.geolocation)
            navigator.geolocation.getCurrentPosition(async (position) => {
                 await addLocation(position.coords,1,send);
            },(error) => {
                console.log(error.message)          
            });
      },5000);//5000
    }





  async function requestPayout() {
    if(total > 0){
        let res = await getRequestBeeppeePayout();
          if(res){
          setPayout({bankName:res.bankName,accountNumber:res.accountNumber,amount:res.amount})
        }
      }else{
        alert("No payout at this time.")
      }
  }




  useEffect(() => {
    sendInterval();
     if(construct(localStorage.getItem(process.env.REACT_APP_LS)) === undefined 
       || construct(localStorage.getItem(process.env.REACT_APP_LS)) === null 
       || localStorage.getItem(process.env.REACT_APP_LS) === undefined ){
       send("/signin");
     }else{
       if(window.location.href.substring(window.location.href.indexOf("?")).includes("?@")){
         setOpenRequest(true);     
        }
        updateLocation();
        pullInActivities();
        pullCommissoinTotal();
        //pullNotificationEvent()
        

        

      }
    },[update])


  return (
    <>
      {open ?
         <div className='absolute lg:w-1/2 w-full h-full  right-0 ml-auto'> <Popup action={toggle}/> </div>
      : null} 

    
      {construct(localStorage.getItem(process.env.REACT_APP_LS))
        === undefined ?
        send("/signin")
        :
      <>
      <GlobalStyle />
       <Shell>
        <Sidebar className="hidden md:flex">
            <div className="flex flex-row align-middle ml-2 mt-5">
              <LogoIcon>
                  <img src={iconlogo} />
              </LogoIcon>
              <LogoText className="self-center ml-2">
                <p>Beeppee console</p>
                <p>Admin Panel</p>
              </LogoText>
            </div>

          <NavSection top>
            <SectionLabel>Main</SectionLabel>
          </NavSection>
            <NavList>
              {navItems.map(item => (
                <NavItem key={item.label} $active={item.active} onClick={(e) => navigations(item.label)}>
                  {item.icon}
                  {item.label}
                </NavItem>
              ))}
            </NavList>
            <Spacer />
          <NavSection>

        

            <SectionLabel>Other</SectionLabel>
            </NavSection>
              <NavList style={{ paddingBottom: 24 }}>
                {bottomNav.map(item => (
                  <NavItem key={item.label} onClick={(e) =>  messageDisplay(item.label,construct(localStorage.getItem(process.env.REACT_APP_LS))['em'],send)}>
                    {item.icon}
                    {item.label}
                  </NavItem>
                ))}
            </NavList>
        </Sidebar>


        {/* ── MAIN ── */}
        <Main>
          <Topbar>
            {isMobile ?
              <div className="flex flex-row align-middle ml-2 mt-0">
              <LogoIcon>
                  <img src={iconlogo} />
              </LogoIcon>
              <LogoText className="self-center ml-2">
                <p>Beeppee console</p>
                <p>Admin Panel</p>
              </LogoText>
            </div>
            :
            <PageTitle>Dashboard</PageTitle>
            }
            <TopbarRight>
              {!isMobile ?
              <SearchWrap>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="11" cy="11" r="8" strokeWidth="2"/>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35"/>
                </svg>
                <SearchInput placeholder="Search…" />
              </SearchWrap>
              : null}

             {!isMobile ?
                <HeaderBell action={toggle}/>
              : null}

              <AvatarRow>
                <Avatar>{construct(localStorage.getItem(process.env.REACT_APP_LS))['em'].toString().toUpperCase().substring(0,1)}</Avatar>
                 {!isMobile ?
                  <AvatarInfo>
                    <p>{construct(localStorage.getItem(process.env.REACT_APP_LS))['cn']}</p>
                    <p>{construct(localStorage.getItem(process.env.REACT_APP_LS))['em']}</p>
                  </AvatarInfo>
                 : null}
                 {isMobile ?
                 <svg width="12" height="12" fill="none" stroke={T.subtle} viewBox="0 0 24 24" onClick={openTopNav}>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>
                 </svg>
                 :null}
              </AvatarRow>
              
             {isMobile ?
                <HeaderBell action={toggle}/>
              : null}

            </TopbarRight>
          </Topbar>

          <Body style={{padding:  openHistory ? "0px" : "24px"}}>

          {openTab ? 
            <div className="absolute z-50 self-end w-[200px] h-[300px] bg-white mt-1 rounded-2xl shadow-xl">
                   <NavList>
                    {navItems.map(item => (
                      <NavItem key={item.label} $active={item.active} onClick={(e) => navigations(item.label)}>
                        {item.icon}
                        {item.label}
                      </NavItem>
                      
                    ))}

                <NavList style={{ paddingBottom: 0,  gap:0, padding:0}}>
                {bottomNav.map(item => (
                  <NavItem key={item.label} onClick={(e) =>  messageDisplay(item.label,construct(localStorage.getItem(process.env.REACT_APP_LS))['em'],send)}>
                    {item.icon}
                    {item.label}
                  </NavItem>
                ))}
            </NavList>
            </NavList>


            </div>
          :null} 
      
          <Greeting>Good Day 👋</Greeting>

            {/* ── STAT CARDS ── */}
            <Row className="flex flex-col md:grid" $cols="repeat(3, 1fr)" $delay="0.05s">
              {[
                { label: "Total Request",      value: total.length, up: filter("n/a",0) > 0 ? true : false,  bg: "#eff6ff", color: T.blue,  icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg> },
                { label: "Request Completed",  value: filter("Complete",1) > 0 ? filter("Complete",1)  : 0, up: filter("Complete",0) > filter("cancel",0) ? true : false,  bg: "#f0fdf4", color: T.green, icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg> },
                { label: "Request Canceled",   value: filter("cancel",1) > 0 ? filter("cancel",1) : 0,  up: filter("Complete",0) <= 0 ? false : filter("Complete",0) < filter("cancel",0) ? false : true, bg: "#fef2f2", color: T.red,   icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg> },
              ].map(s => (
                <StatCard key={s.label}>
                  <StatIcon $bg={s.bg} $color={s.color}>{s.icon}</StatIcon>
                  <StatLabel>{s.label}</StatLabel>
                  <StatValueRow>
                    <StatValue>{s.value}</StatValue>
                    <StatArrow $up={s.up}>
                      {s.up
                        ? <svg width="12" height="12" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
                        : <svg width="12" height="12" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd"/></svg>
                      }
                    </StatArrow>
                  </StatValueRow>
                </StatCard>
              ))}
            </Row>

            {/* ── REVENUE + RIGHT ── */}
            <Row className="flex flex-col md:grid" $cols="repeat(3, 1fr)" $delay="0.05s">

              {/* Revenue */}
              <RevenueCard >
                <RevenueHeader>
                  <CardTitle>Total Revenue</CardTitle>
                  <PeriodSelect onClick={(e) => total > 0 ? setUpdate(update+1) : null}>
                    Refresh
                  </PeriodSelect>
                </RevenueHeader>
                <NetVolRow><CyanDot /><NetVolLabel>Net Volume</NetVolLabel></NetVolRow>
                <RevenueAmountRow>
                  <RevenueAmount>NGN{profit}</RevenueAmount>
                  {profit != 0 ? <GrowthBadge>↑ +10%</GrowthBadge>:null}
                </RevenueAmountRow>
              

               <RevenueHeader>
                  <CardTitle>Outstanding</CardTitle>
                  <PeriodSelect onClick={(e) => requestPayout()}>
                    Pay now
                  </PeriodSelect>
                </RevenueHeader>
                <NetVolRow><CyanDot /><NetVolLabel>Net Volume</NetVolLabel></NetVolRow>
                <RevenueAmountRow>
                  <RevenueAmount>NGN -{roundUpToDecimal(outstanding,2)}</RevenueAmount>
                  {/* {outstanding != 0 ? <GrowthBadge>10%</GrowthBadge>:null} */}
                </RevenueAmountRow>


                  {payout != null ?
                   <div>
                    <RevenueHeader>
                      <CardTitle>Beeppee Bank details</CardTitle>
                    </RevenueHeader>
                    <NetVolRow><CyanDot /><NetVolLabel>{payout.accountNumber}</NetVolLabel></NetVolRow>
                    <RevenueAmountRow>
                      <RevenueAmount>NGN -{roundUpToDecimal(payout.amount,2)}</RevenueAmount>
                      <GrowthBadge>{payout.bankName}</GrowthBadge>
                    </RevenueAmountRow>
                  </div>
             : null}

              </RevenueCard>

              {/* Right column */}
              <div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop:"0px" }}>

                {/* Satisfaction */}
                <SatisfactionCard>
                  <CardTitle>Customers Satisfaction</CardTitle>
                  {total.length > 0 ? <>
                  <GaugeWrap><GaugeCanvas value={Math.ceil(getOrderRating(total).ratingPercent)} /></GaugeWrap>
                  <GaugeLabels><span>0</span><span>100</span></GaugeLabels>
                  </>: null}
                  <SatisfactionHint>
                    {total.length > 0 ? <>
                    <HintEmoji>😊</HintEmoji>
                    <HintText>
                      <p>Good progress, but there's still room to improve.</p>
                      <p>Positive feedback is the key to business growth. Focus on quality services and better relationships.</p>
                    </HintText>
                    </>: <HintText>
                         <p>No data at this time.</p>
                        </HintText>}
                  </SatisfactionHint>
                </SatisfactionCard>

                {/* Analytics */}
               
              
                <AnalyticsCard>
                  <CardTitle>Request Analytics</CardTitle>
                   <AnalyticsBody> 
                    
                      <DonutWrap>
                    
                        {donutData  && donutData.length > 0 ?(
                            <PieChart width={110} height={110}>
                             <Pie data={donutData} cx={50} cy={50} innerRadius={36} outerRadius={52} dataKey="value" startAngle={90} endAngle={-270} strokeWidth={0}>
                             {donutData.map((d, i) => <Cell key={i} fill={d.color}/>)}
                             </Pie> 
                          </PieChart>)
                         :""}
                      
                      
                      <DonutCenter>
                        {donutData  && donutData.length > 0 ?
                        <p>{Math.ceil(donutData[0].value)}%</p>
                        : null}
                        <p>Completed</p>
                      </DonutCenter>
                      </DonutWrap>
                    
                    
                    <LegendList>
                      {donutData  && donutData.length > 0 ?
                        donutData.map(d => (
                         <LegendItem key={d.name}>
                          <LegendDot $color={d.color}/>
                          <LegendLabel>{d.name}</LegendLabel>
                          <LegendValue $color={d.color}>{Math.ceil(d.value)}%</LegendValue>
                        </LegendItem>
                        
                      )) : null}
                    </LegendList>
                  </AnalyticsBody>
                </AnalyticsCard>
                
              </div>
            </Row>

          </Body>

             
      
           {openRequest ?
               <div className='absolute w-full h-full z-50 bg-slate-300  flex justify-center'>
                     <Request clicker={openOrder}/>
               </div>
            :null}



            {openHistory ?
               <div className='w-full h-full bg-slate-300 flex justify-center'>
                     <Requesthistory />
               </div>
            :null}


           {openBusiness ?
            <div className='absolute w-full h-[100vh] bg-slate-300 flex justify-center mt-16'>
                <CenterPage action={mapBusiness}/> </div>
           :null}

        </Main>
      </Shell>
       </>
      } 
    </>
    
  );
}


export default Console;